/* LOGIXA homepage content — UA. Shape must match de.ts exactly. */

export const ua = {
  nav: {
    links: [
      { label: 'Продукт', href: '#plattform' },
      { label: 'Рішення', href: '#disposition' },
      { label: 'Інтеграції', href: '#integrationen' },
      { label: 'Ціни', href: '#preise' },
      { label: 'Ресурси', href: '/docs' },
    ],
    login: 'Вхід',
    demo: 'Замовити демо',
    menu: 'Меню',
  },

  hero: {
    kicker: 'TRANSPORT MANAGEMENT SYSTEM',
    h1: 'TMS-система для транспортних компаній, яким замало самої диспетчеризації.',
    sub: 'Замовлення, диспетчеризація, водії, автопарк, GPS, документи та розрахунки в одній платформі. LOGIXA зв’язує всю транспортну організацію — від замовлення до рахунку.',
    primary: 'Замовити демо',
    secondary: 'Дивитися демо',
    trust: ['Відповідність GDPR', 'Хостинг у Німеччині', '9 мов', 'Запуск за 12 днів'],
    demoNote: 'Демонстраційні дані',
  },

  mock: {
    search: 'Пошук…',
    user: 'Max Mustermann',
    role: 'ADMIN',
    nav: ['Огляд', 'Замовлення', 'Диспетчеризація', 'Транспорт', 'Водії', 'Планування рейсів', 'GPS-моніторинг', 'Документи', 'Повідомлення', 'Звіти', 'Розрахунки', 'Налаштування'],
    live: 'LIVE',
    card: {
      id: 'FLEET-DEMO-118',
      route: 'Гамбург, DE → Роттердам, NL',
      etaLbl: 'ETA',
      eta: 'Сьогодні, 14:30',
      driverLbl: 'ВОДІЙ',
      driver: 'John D.',
      progress: 64,
    },
    ordersTitle: 'Активні замовлення',
    orders: [
      { id: 'FLEET-DEMO-118', state: 'У ДОРОЗІ', tone: 'go' },
      { id: 'FLEET-DEMO-117', state: 'У ДОРОЗІ', tone: 'go' },
      { id: 'FLEET-DEMO-116', state: 'ЗАВАНТАЖЕННЯ', tone: 'load' },
      { id: 'FLEET-DEMO-115', state: 'ЗАПЛАНОВАНО', tone: 'plan' },
      { id: 'FLEET-DEMO-114', state: 'ЗАВЕРШЕНО', tone: 'done' },
    ],
    kpiTitle: 'KPI сьогодні',
    kpis: [
      { lbl: 'ЗАМОВЛЕННЯ', val: '850', delta: '+14 %' },
      { lbl: 'ПОРОЖНІ', val: '14 %', delta: '−16 %' },
      { lbl: 'ВИРУЧКА', val: '€92K', delta: '+18 %' },
    ],
    statusTitle: 'Статус транспорту',
    status: [
      { n: '104', lbl: 'У ДОРОЗІ' },
      { n: '18', lbl: 'ЗАВАНТАЖЕННЯ' },
      { n: '7', lbl: 'РОЗВАНТАЖЕННЯ' },
      { n: '4', lbl: 'СЕРВІС' },
      { n: '2', lbl: 'ПРОСТІЙ' },
    ],
    plates: [
      { p: 'HH-LOG 33', tone: 'go' },
      { p: 'B-KT 155', tone: 'acc' },
      { p: 'K-AB 147', tone: 'idle' },
    ],
  },

  integrations: {
    label: 'Інтегрується у вашу наявну\nлогістичну інфраструктуру',
    items: ['TIMOCOM', 'Trans.eu', 'DATEV', 'Stripe', 'SEPA', 'n8n', 'Make', 'Zapier'],
  },

  platform: {
    kicker: 'ПЛАТФОРМА',
    h2: 'Ваша компанія. Одна система.',
    sub: 'Жодних Excel-таблиць. Жодних окремих систем для водіїв, GPS і розрахунків. Жодного пошуку інформації в п’яти інструментах.',
    areas: [
      {
        n: '01',
        title: 'Замовлення та диспетчеризація',
        desc: 'Створювати замовлення, призначати водіїв і транспорт, планувати рейси та стежити за статусом перевезення в реальному часі.',
        chips: ['Замовлення', 'AI-диспетчер', 'Планування', 'ePOD'],
      },
      {
        n: '02',
        title: 'Автопарк і GPS',
        desc: 'Відстежувати транспорт онлайн, планувати сервіс, контролювати TCO та керувати геозонами.',
        chips: ['Live GPS', 'TCO', 'Сервіс', 'Геозони'],
      },
      {
        n: '03',
        title: 'Водії та комплаєнс',
        desc: 'Робочий час, документи, тахограф і правила EU 561 в одному місці — до того, як строки стануть проблемою.',
        chips: ['Тахограф', 'EU 561', 'ADR', 'Модуль 95'],
      },
      {
        n: '04',
        title: 'Розрахунки та фінанси',
        desc: 'Зарплати, надбавки, виплати й процеси DATEV напряму пов’язані з операційними даними перевезень.',
        chips: ['Payroll', 'DATEV', 'SEPA', 'Stripe'],
      },
    ],
    cta: 'Переглянути всі функції',
  },

  dispatch: {
    kicker: 'РОЗУМНА ДИСПЕТЧЕРИЗАЦІЯ',
    h2: 'Диспетчеризація, яка думає.',
    sub: 'LOGIXA враховує водіїв, транспорт, режим праці й відпочинку, доступність і маршрут — і допомагає диспетчеру обрати оптимальне призначення.',
    points: [
      { title: 'AI-диспетчер', desc: 'Пропонує водія й транспорт під конкретне замовлення.' },
      { title: 'Оптимізація маршруту', desc: 'Враховує платні дороги, відстань, режим праці та пальне.' },
      { title: 'Diesel Intelligence', desc: 'Планує заправки за актуальними цінами на пальне вздовж маршруту.' },
    ],
    panelTitle: 'Рекомендація маршруту',
    metrics: [
      { lbl: 'Відстань', val: '1 346 км' },
      { lbl: 'Час у дорозі', val: '17 год 25 хв' },
      { lbl: 'Платні дороги', val: '€ 128,40' },
      { lbl: 'CO₂', val: '1 245 кг' },
    ],
    stopsTitle: 'Рекомендовані заправки',
    live: 'LIVE',
    stops: [
      { city: 'Ганновер', price: '€ 1,59', best: false },
      { city: 'Кассель', price: '€ 1,58', best: false },
      { city: 'Франкфурт', price: '€ 1,55', best: true },
      { city: 'Вюрцбург', price: '€ 1,62', best: false },
    ],
    apply: 'Прийняти маршрут',
    source: 'Джерела цін: Tankerkönig (DE), prix-carburants (FR), E-Control (AT), MITECO (ES)',
  },

  driver: {
    kicker: 'ЗАСТОСУНОК ВОДІЯ',
    h2: 'У водія все з собою.',
    sub: 'Нативні застосунки для iOS та Android — повний цикл рейсу від замовлення до підпису, зокрема без мережі.',
    flow: ['Отримати замовлення', 'Запустити навігацію', 'Сканувати документи', 'Підписати ePOD', 'Закрити рейс'],
    chips: ['iOS', 'Android', 'Офлайн-режим', 'Telegram-бот', '9 мов'],
    phones: [
      {
        tag: 'ЗАМОВЛЕННЯ #DE-1107',
        title: 'Гамбург → Роттердам',
        rows: [
          { lbl: 'ЗАВАНТАЖЕННЯ', val: 'Сьогодні 08:30' },
          { lbl: 'РОЗВАНТАЖЕННЯ', val: 'Сьогодні 14:30' },
          { lbl: 'ТРАНСПОРТ', val: 'HH-LOG 33' },
          { lbl: 'ВАНТАЖ', val: '18 палет · 12,4 т' },
        ],
        action: 'Запустити навігацію',
      },
      {
        tag: 'ДОКУМЕНТИ',
        title: 'Сканувати CMR',
        rows: [
          { lbl: 'НАКЛАДНА', val: 'CMR-2026-4471' },
          { lbl: 'СТАТУС', val: 'Відскановано · 2 стор.' },
          { lbl: 'АКТ ПРИЙМАННЯ', val: 'Очікується' },
        ],
        action: 'Завантажити скан',
      },
      {
        tag: 'ePOD',
        title: 'Підтвердити приймання',
        rows: [
          { lbl: 'ОТРИМУВАЧ', val: 'De Vries Logistics BV' },
          { lbl: 'ПІДПИС', val: 'Отримано' },
          { lbl: 'ФОТО', val: '3 вкладення' },
        ],
        action: 'Закрити рейс',
      },
    ],
  },

  compliance: {
    kicker: 'КОМПЛАЄНС І БЕЗПЕКА',
    h2: 'Бачити режим праці до того, як він стане проблемою.',
    sub: 'Час керування та відпочинку, дані тахографа й документи, що спливають, в одному місці — з попередженням, поки ще є час зреагувати.',
    points: [
      { title: 'EU 561', desc: 'Актуальний час керування та відпочинку по кожному водієві, постійна звірка.' },
      { title: 'Тахограф', desc: 'Імпорт DDD-файлів і контроль даних водія.' },
      { title: 'Документи', desc: 'Попередження про закінчення посвідчення, ADR і Модуля 95.' },
    ],
    dashDriverLbl: 'Водій',
    dashDriver: 'John D.',
    badge: 'ВІДПОВІДАЄ',
    bars: [
      { lbl: 'Керування сьогодні', val: '7 год 45 / 9 год', pct: 86, tone: 'warn' },
      { lbl: 'Керування за тиждень', val: '38 год 10 / 56 год', pct: 68, tone: 'ok' },
      { lbl: 'Наступний відпочинок', val: 'через 1 год 15 хв', pct: 42, tone: 'ok' },
    ],
    docsTitle: 'Документи, що спливають',
    docs: [
      { lbl: 'Посвідчення водія', val: '12.03.2027', warn: false },
      { lbl: 'Сертифікат ADR', val: '18.05.2027', warn: true },
      { lbl: 'Модуль 95', val: '22.09.2027', warn: false },
    ],
    alerts: '3 АКТИВНІ ПОПЕРЕДЖЕННЯ',
  },

  onboarding: {
    kicker: 'ПЕРЕХІД',
    h2: 'Досі Excel? Не проблема.',
    sub: 'Переносимо водіїв, транспорт і контрагентів з Excel, CSV або вашої нинішньої TMS.',
    promoTitle: 'Запуск за 12 днів.',
    promoSub: 'Швидко. Надійно. Без ризику.',
    promoCta: 'Замовити демо',
    steps: [
      { tag: 'ДЕНЬ 1', title: 'Розбір процесів', desc: 'Демо й аналіз ваших процесів.' },
      { tag: 'ДЕНЬ 2–4', title: 'Пілот', desc: 'Пілотна експлуатація на реальних машинах.' },
      { tag: 'ДЕНЬ 5–8', title: 'Імпорт даних', desc: 'Перенесення водіїв, транспорту й довідників.' },
      { tag: 'ДЕНЬ 9–10', title: 'Навчання', desc: 'Навчання диспетчерів і водіїв.' },
      { tag: 'ДЕНЬ 11–12', title: 'Запуск', desc: 'Продуктивний старт із повною підтримкою.' },
    ],
  },

  roi: {
    kicker: 'ПОТЕНЦІАЛ ЕКОНОМІЇ',
    h2: 'Що LOGIXA змінює у вашому парку.',
    fields: [
      { lbl: 'Транспорт', unit: '' },
      { lbl: 'Водії', unit: '' },
      { lbl: 'Замовлень на місяць', unit: '' },
      { lbl: 'Середній пробіг на машину за рік', unit: 'км' },
    ],
    panelTitle: 'ПОТЕНЦІАЛ НА РІК',
    lines: ['Менше адміністративної роботи', 'Оптимізація порожніх пробігів', 'Оптимізація пального'],
    totalLbl: 'Оцінковий потенціал',
    basisLink: 'Показати методику розрахунку',
    basisClose: 'Сховати методику розрахунку',
    basis: [
      'Адміністрування: 7,50 € на замовлення (близько 13 хвилин за ставки 34 €/год) плюс 15 € на водія на місяць на облік часу та підготовку зарплати.',
      'Порожні пробіги: частка порожнього пробігу 18 %, з них 5 % усувні завдяки кращій диспетчеризації, за вартості 1,04 € за кілометр.',
      'Пальне: витрата 30 л на 100 км і економія 2 центи на літр завдяки плануванню заправок уздовж маршруту — за актуальними цінами Tankerkönig (DE), prix-carburants (FR), E-Control (AT) та MITECO (ES).',
      'Усі значення — оцінка на основі типових галузевих припущень, а не гарантована економія.',
    ],
  },

  pricing: {
    kicker: 'ЦІНИ',
    h2: 'Прозорі ціни. Передбачувано. Чесно.',
    sub: 'Оберіть тариф під розмір вашого парку. Скасування щомісяця.',
    allLink: 'Усі тарифи',
    perMonth: '/ місяць',
    badge: 'РЕКОМЕНДУЄМО',
    cta: 'Замовити демо',
    plans: [
      {
        name: 'STARTER', price: '€199', custom: false, scope: 'до 15 машин',
        features: ['Керування замовленнями', 'Застосунок водія', 'GPS-моніторинг', 'Підтримка email'],
      },
      {
        name: 'BUSINESS', price: '€499', custom: false, scope: 'до 50 машин',
        features: ['Усі функції Starter', 'AI-диспетчер', 'Тахограф і EU 561', 'Пріоритетна підтримка'],
      },
      {
        name: 'ENTERPRISE', price: 'Індивідуально', custom: true, scope: 'від 50 машин',
        features: ['Усі функції Business', 'Розширені права доступу', 'API та інтеграції', 'Персональний менеджер'],
      },
    ],
    note: ['Менші парки стартують дешевше: ', 'BASIC від 49 €/місяць', ' до 3 машин, ', 'DRIVER безкоштовно', ' для ФОП з одним тягачем.'],
  },

  security: {
    title: 'Ваші дані залишаються в Європі.',
    items: ['Хостинг у Німеччині', 'Відповідність GDPR', '2FA і Passkeys', 'Журнали аудиту', 'Шифрування при зберіганні'],
  },

  faq: {
    kicker: 'FAQ',
    h2: 'Часті питання про TMS.',
    sub: 'Залишилися питання? Відповімо на демо.',
    list: [
      {
        q: 'Що таке TMS-система?',
        a: 'Transport Management System об’єднує обробку замовлень, диспетчеризацію, керування транспортом і водіями, документи та розрахунки в одній платформі — замість розрізнених Excel-таблиць, GPS-порталів і бухгалтерських програм.',
      },
      {
        q: 'Яким компаніям підходить LOGIXA?',
        a: 'Транспортним компаніям від 3 до понад 50 машин. ФОП з одним тягачем стартують на безкоштовному тарифі DRIVER, невеликі парки — на BASIC від 49 €/місяць, середні компанії — на STARTER або BUSINESS.',
      },
      {
        q: 'Чи може LOGIXA замінити Excel?',
        a: 'Так. Замовлення, водії, транспорт, довідники та розрахунки живуть в одній базі, а не в розрізнених таблицях. Наявні файли Excel і CSV ми переносимо під час переходу — ви стартуєте на своїх даних.',
      },
      {
        q: 'Скільки триває впровадження?',
        a: 'Ми плануємо перехід за 12 днів: аналіз процесів, пілот на реальних машинах, імпорт даних, навчання та запуск. Це наш регламент роботи, а не усереднений показник за клієнтськими проєктами.',
      },
      {
        q: 'Чи можна залишити наявний GPS?',
        a: 'У багатьох випадках так. LOGIXA знімає позиції через застосунок водія без додаткового обладнання і паралельно може приймати телематику з наявних систем. Який варіант підключення можливий у вас — визначаємо до старту.',
      },
      {
        q: 'Чи підтримує LOGIXA тахограф і EU 561?',
        a: 'Час керування та відпочинку за EU 561 рахується по кожному водієві постійно, з попередженнями до перевищення. DDD-файли тахографа можна імпортувати й переглядати; як офіційна розшифровка тахографа для контролюючих органів ця обробка не призначена.',
      },
      {
        q: 'Чи є застосунок для водія?',
        a: 'Так, нативні застосунки для iOS та Android дев’ятьма мовами: замовлення, навігація, скан документів, підпис ePOD і закриття рейсу — зокрема офлайн. Додатково є Telegram-бот для водіїв без встановленого застосунку.',
      },
      {
        q: 'Чи можна підключити TIMOCOM і Trans.eu?',
        a: 'Конектори підготовлені й написані за документованими інтерфейсами. Активація йде через ваш власний договір з TIMOCOM або Trans.eu; під час впровадження ми налаштовуємо з’єднання разом і тестуємо його з вашими доступами.',
      },
      {
        q: 'Де зберігаються дані?',
        a: 'На серверах у Німеччині, відповідно до GDPR, із шифруванням під час передавання та зберігання. Доступи протоколюються, вхід можна захистити 2FA і Passkeys.',
      },
      {
        q: 'Скільки коштує LOGIXA?',
        a: 'DRIVER безкоштовний для ФОП з одним тягачем, BASIC починається з 49 €/місяць до 3 машин, STARTER коштує 199 €/місяць до 15 машин, BUSINESS — 499 €/місяць до 50 машин. Від 50 машин рахуємо індивідуально. Усі тарифи скасовуються щомісяця.',
      },
    ],
  },

  finalCta: {
    h2: 'Подивіться LOGIXA на своїх транспортних процесах.',
    sub: 'За 30 хвилин демо покажемо саме ті модулі, які важливі для вашого парку.',
    primary: 'Замовити демо',
    secondary: 'Дивитися демо',
  },

  footer: {
    tagline: 'TMS-система для транспортних та експедиторських компаній у Європі.',
    cols: [
      {
        title: 'ПРОДУКТ',
        links: [
          { label: 'Функції', href: '/platform/funktionen' },
          { label: 'AI-диспетчер', href: '/platform/ki' },
          { label: 'Застосунок водія', href: '/platform/funktionen#apps' },
          { label: 'Планування рейсів', href: '/platform/funktionen#tourenplanung' },
          { label: 'Розрахунки', href: '/platform/backoffice' },
        ],
      },
      {
        title: 'РІШЕННЯ',
        links: [
          { label: 'Невеликі компанії', href: '/pricing' },
          { label: 'Середні автопарки', href: '/pricing' },
          { label: 'Міжнародні перевезення', href: '/platform/funktionen' },
          { label: 'Водії-ФОП', href: '/pricing' },
        ],
      },
      {
        title: 'ІНТЕГРАЦІЇ',
        links: [
          { label: 'TIMOCOM', href: '/platform/integrationen' },
          { label: 'Trans.eu', href: '/platform/integrationen' },
          { label: 'DATEV', href: '/platform/integrationen' },
          { label: 'Telegram', href: '/platform/integrationen' },
          { label: 'Усі інтеграції', href: '/platform/integrationen' },
        ],
      },
      {
        title: 'РЕСУРСИ',
        links: [
          { label: 'База знань', href: '/docs' },
          { label: 'Блог', href: '/blog' },
          { label: 'Що таке TMS?', href: '/docs' },
          { label: 'Вартість TMS', href: '/pricing' },
          { label: 'Центр допомоги', href: '/docs' },
        ],
      },
      {
        title: 'КОМПАНІЯ',
        links: [
          { label: 'Про нас', href: '/about' },
          { label: 'Вакансії', href: '/jobs' },
          { label: 'Партнери', href: '/companies' },
          { label: 'Контакти', href: '/kontakt' },
        ],
      },
    ],
    copyright: '© 2026 LOGIXA. Усі права захищено.',
    legal: [
      { label: 'Конфіденційність', href: '/datenschutz' },
      { label: 'Імпресум', href: '/impressum' },
      { label: 'Умови', href: '/agb' },
      { label: 'Безпека', href: '/platform/funktionen#sicherheit' },
    ],
  },
};
